import { fwnWidgetsGetter } from './widgets'

/**
 * Attach `widgets` property to `window._fwn`
 */
export function attach() {
  if (
    typeof window !== 'undefined' &&
    !Object.prototype.hasOwnProperty.call(window._fwn, 'widgets')
  ) {
    Object.defineProperty(window._fwn, 'widgets', {
      get: fwnWidgetsGetter,
    })
  }
}
